// Official YANRE FITNESS logo — exact transparent brand asset (dark-bg version).
// Never redrawn, recolored, cropped or placed on a background chip.
export const Logo = ({ className = "" }) => (
  <img
    src="/yanre-logo.webp"
    alt="YANRE FITNESS"
    className={`h-7 w-auto sm:h-8 ${className}`}
    data-testid="yanre-logo"
  />
);
